/** Axios-style errors and generic Errors → user-visible string. */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
): string {
  const e = error as {
    response?: { data?: { message?: string } };
    message?: string;
  };
  const msg = e?.response?.data?.message;
  if (typeof msg === "string" && msg.trim() !== "") return msg;
  if (typeof e?.message === "string" && e.message.trim() !== "") return e.message;
  return fallback;
}
